import { FC, useEffect } from 'react'
import { Control, DomEvent, DomUtil } from 'leaflet'
import { createPortal } from 'react-dom'
import { useMap } from 'react-leaflet'
import { Modal, Props as ModalProps } from '../../Modal'

const controlContainer = DomUtil.create('div')
const LeafletControl = Control.extend({
  onAdd() {
    DomEvent.disableClickPropagation(controlContainer)
    DomEvent.disableScrollPropagation(controlContainer)

    return controlContainer
  },
})

export const MapModal: FC<ModalProps> = ({ children, ...props }) => {
  const map = useMap()

  useEffect(() => {
    const control = new LeafletControl()

    map.addControl(control)

    return () => {
      map.removeControl(control)
    }
  }, [map])

  return createPortal(<Modal {...props}>{children}</Modal>, controlContainer)
}
